<template>
  <div class="mall-quick-menu">
    <div
      v-for="item in items"
      :key="item.key"
      class="mall-quick-menu__item"
      @click="$emit('click', item.key)"
    >
      <div class="mall-quick-menu__icon-box">
        <div class="mall-quick-menu__icon" :class="'mall-quick-menu__icon--' + item.key">
          <img :src="item.icon" alt="" />
        </div>
      </div>
      <span class="mall-quick-menu__label">{{ item.label }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MallQuickMenu',
  data() {
    return {
      items: [
        { key: 'booking', label: '진료예약', icon: require('@/assets/mall/icn_calendar_check_color.svg') },
        { key: 'cart', label: '장바구니', icon: require('@/assets/mall/icn_shopping_fill.svg') },
        { key: 'card', label: '카드변경', icon: require('@/assets/mall/icn_card_color.svg') },
        { key: 'address', label: '배송지관리', icon: require('@/assets/mall/icn_location_fill.svg') },
        { key: 'history', label: '이용내역', icon: require('@/assets/mall/icn_write_paper_2d.svg') },
      ],
    }
  },
}
</script>

<style scoped>
.mall-quick-menu {
  display: flex;
  padding: 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  background: #F2F4F6;
}

.mall-quick-menu__item {
  display: flex;
  flex-shrink: 0;
  width: 60px;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}

.mall-quick-menu__icon-box {
  display: flex;
  padding: 12px;
  border: 1px solid #E5E8EB;
  border-radius: 20px;
  background: #FFF;
}

.mall-quick-menu__icon {
  position: relative;
  width: 28px;
  height: 28px;
  overflow: hidden;
}

.mall-quick-menu__icon img {
  display: block;
}

/* 카드 아이콘은 28px 영역보다 넓게 배치된 그래픽 (Figma 기준 위치) */
.mall-quick-menu__icon--card img {
  position: absolute;
  top: 2.23px;
  left: -1px;
}

/* 13px / 130% → Figma 렌더링 기준 17px */
.mall-quick-menu__label {
  width: 60px;
  color: #4E5968;
  font-family: Pretendard;
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
  line-height: 17px;
  text-align: center;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/new/molecules/MallQuickMenu.vue